// extracted by mini-css-extract-plugin
export default {"search_box_container":"SearchBox_search_box_container__Xsz1S","autocomplete_wrap":"SearchBox_autocomplete_wrap__0obrb","error_text":"SearchBox_error_text__mcAi6"};